import { MembershipType } from "../payWall/paywall.model";

export const membershipStyles: Record<MembershipType, React.CSSProperties> = {
  Free: { color: 'lightgreen', fontWeight: 'bold', backgroundColor: '#141414' },
  Novice: { color: '#1976d2', fontWeight: 'bold', backgroundColor: '#141414' },
  Pro: { color: 'gold', fontWeight: 'bold', backgroundColor: '#141414' },
};

export const comingSoonStyle: React.CSSProperties = {
  color: 'lightblue',
};